import axiosInstance from "../utils/axios";

// Update the user's Firebase Cloud Messaging token
export const updateDeviceTokenAPI = async (deviceToken: string, deviceType: string = "web") => {
  try {
    const response = await axiosInstance.post("/api/user/auth/update-device-token", {
      device_token: deviceToken,
      device_type: deviceType,
    });
    return response.data;
  } catch (error: any) {
    console.error("Error updating device token:", error);
    throw new Error(error.response?.data?.message || "Failed to update device token");
  }
};

// Get the user's notifications (paginated)
export const getNotificationsAPI = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await axiosInstance.get(`/api/user/notification/list?page=${page}&limit=${limit}`);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error fetching notifications list:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch notifications list");
  }
};

// Clear (delete) all notifications
export const clearNotificationsAPI = async () => {
  try {
    const response = await axiosInstance.post("/api/user/notification/clear-all");
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error clearing notifications:", error);
    throw new Error(error.response?.data?.message || "Failed to clear notifications");
  }
};

// Get details of a single notification (marks as read)
export const getNotificationDetailAPI = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/api/user/notification/detail/${id}`);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  } catch (error: any) {
    console.error("Error fetching notification detail:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch notification detail");
  }
};
